import AdminGeneralSettingsPage from '../../../components/admin/settings/AdminGeneralSettingsPage'

export default function SettingsGeneral() {
  return <AdminGeneralSettingsPage />
}
